import { Component } from '@angular/core';

export interface ToastData {
  id: number;
  message: string;
  snackType: string;
  duration: number;
}

@Component({
  selector: 'frodo-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent {
  toasts: ToastData[] = [];
  dismiss: (id: number) => void = () => undefined;

  trackById(_index: number, toast: ToastData): number {
    return toast.id;
  }
}
